import PropTypes from 'prop-types';
import { useMemo } from 'react';

// Our Components
import Modal from 'components/Modal/Modal';
import TradelineContent from 'components/Tradeline/TradelineContent';
import KeyActionContent from 'components/Cards/KeyActions/KeyActionContent';
import TasksAccordion from 'components/Tasks/TasksAccordion';

// Our Utils
import formatKeyActionName from 'shared/utils/formatting/keyaction/formatKeyActionName';

function PreviewKeyAction({ isOpen, handleClose, keyActionInfo }) {
	const {
		keyActionName,
		clientFirstName,
		clientLastName,
		tradelineId,
		keyActionQualification
	} = keyActionInfo;

	const formattedKeyActionName = useMemo(
		() => formatKeyActionName(keyActionName),
		[keyActionName]
	);

	return (
		<Modal
			isOpen={isOpen}
			handleClose={handleClose}
			title={`Key Action - ${formattedKeyActionName} for ${clientFirstName} ${clientLastName}`}
			subtitle="This is a preview of the key action."
		>
			<TasksAccordion taskHeading="View Trade Line Data">
				<TradelineContent tradelineId={tradelineId} />
			</TasksAccordion>
			<TasksAccordion
				taskHeading="Key Action Qualifications"
				defaultExpandState
			>
				<KeyActionContent
					withHeading={false}
					keyActionQualification={keyActionQualification}
				/>
			</TasksAccordion>
		</Modal>
	);
}

PreviewKeyAction.propTypes = {
	primaryButtonText: PropTypes.string.isRequired,
	confirmButtonCallback: PropTypes.func.isRequired,
	disable: PropTypes.bool
};

PreviewKeyAction.defaultProps = {
	primaryButtonText: 'Archive',
	disable: false
};

export default PreviewKeyAction;
